import React, { Fragment } from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import mobileStrokeImg from './img/mobile-stroke.svg'
import desktopStrokeImg from './img/desktop-stroke.svg'
import desktopAmpersandSVGImg from './img/desktop-ampersand.svg'
import mobileAmpersandSVGImg from './img/mobile-ampersand.svg'
import backgroundImg from './img/background.jpg'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData,
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const { coupleSingleName, weddingDate } = coupleData

  const text =
    new Date() > new Date(weddingDate.timestamp)
      ? 'JÁ SE CASARAM!'
      : 'VÃO SE CASAR!'

  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro273">
      <div className="intro273mobile screen">
        <img
          alt="Image/"
          className="main-background-mmlgp8"
          src={background || backgroundImg}
        />
        <div className="mask-mmlgp8"></div>
        <img src={mobileStrokeImg} className="stroke-mmlgp8" />
        <div className="container-center-horizontal">
          <div className="button-mmlgp8">
            <p
              className="site-de-casamento-e-PvAxzg"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-PvAxzg" onClick={onSkipIntro}>
              <div className="button-23ZcLC"></div>
              <div className="pular-introduo-23ZcLC">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="container-center-vertical container-center-horizontal">
          <div className="content-mmlgp8">
            <div className="stacked-group-b0eKD2">
              <div className="vo-se-casar-sZK8so bp1-intro273-animate-enter2">
                {text}
              </div>
              <div className="couple-name-sZK8so">
                <div className="notranslate mariana-lDuGdQ abidingloveserif-normal-white-34px bp1-intro273-animate-enter1">
                  {coupleSingleName.groom
                    ? coupleSingleName.bride[0]
                    : coupleSingleName.bride}
                </div>
                {!!coupleSingleName.groom && (
                  <Fragment>
                    <img
                      src={mobileAmpersandSVGImg}
                      className="ampersand-lDuGdQ"
                    />
                    <div className="notranslate eduardo-lDuGdQ abidingloveserif-normal-white-34px bp1-intro273-animate-enter">
                      {coupleSingleName.groom[0]}
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="intro273desktop screen">
        <img
          alt="Image/"
          className="main-background-YdbGEE bp2-intro273-animate-enter"
          src={background || backgroundImg}
        />
        <div className="mask-YdbGEE"></div>
        <img src={desktopStrokeImg} className="stroke-YdbGEE" />
        <div className="container-center-horizontal">
          <div className="button-YdbGEE">
            <p
              className="site-de-casamento-e-DphfPw"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-DphfPw" onClick={onSkipIntro}>
              <div className="button-J0lgZ4"></div>
              <div className="pular-introduo-J0lgZ4">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="container-center-vertical container-center-horizontal">
          <div className="content-YdbGEE">
            <div className="content-cji30m">
              <div className="vo-se-casar-gUtuIV bp2-intro273-animate-enter3">
                {text}
              </div>
              <div className="couple-name-gUtuIV">
                <div className="notranslate mariana-ov3yhz abidingloveserif-normal-white-34px bp2-intro273-animate-enter2">
                  {coupleSingleName.groom
                    ? coupleSingleName.bride.split(' ')[0]
                    : coupleSingleName.bride}
                </div>
                {!!coupleSingleName.groom && (
                  <Fragment>
                    <img
                      src={desktopAmpersandSVGImg}
                      className="ampersand-ov3yhz"
                    />
                    <div className="notranslate eduardo-ov3yhz abidingloveserif-normal-white-34px bp2-intro273-animate-enter1">
                      {coupleSingleName.groom.split(' ')[0]}
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
